// import css
import Classes from "./style/Lonading.module.css";
export default function ParallaxEffect() {
  return (
    <section className={Classes.sectionParallax}>
      <div className={Classes.overlay}></div>
      <div className={Classes.containerOfParallax}>
        <h2 className={Classes.parallaxHeading}>
          Hey am <span>Abir</span> & <span>Web Developer</span>
        </h2>
        <code style={{ fontSize: "2rem", color: "#fff" }}>
          If you want to create such think you can hire us.
        </code>
      </div>
    </section>
  );
}
